import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { ButtonComponent, HeadingComponent, RadioComponent } from '@core/user-interface-legacy';

import { ChoicePayload, ChoiceResume } from '../schemas';

@Component({
  selector: 'tellent-assistant-choice-interrupt',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonComponent, HeadingComponent, RadioComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <rt-heading variant="subheading" id="choice-prompt" class="prompt">{{
      payload().prompt
    }}</rt-heading>
    <ul class="options" role="radiogroup" aria-labelledby="choice-prompt">
      @for (option of payload().options; track option.id) {
        <li>
          <rt-radio [formControl]="control" [value]="option.id">
            {{ option.label ?? option.id }}
          </rt-radio>
        </li>
      }
    </ul>
    @if (!resolved()) {
      <footer class="actions">
        <rt-button variant="primary" size="small" [disabled]="!control.value" (click)="submit()">
          Confirm
        </rt-button>
      </footer>
    }
  `,
  styleUrls: ['./choice-interrupt.component.less'],
})
export class TellentAssistantChoiceInterruptComponent {
  public readonly payload = input.required<ChoicePayload>();
  public readonly resolved = input<boolean>(false);
  public readonly resolve = output<ChoiceResume>();
  public readonly cancel = output<void>();

  protected readonly control = new FormControl<string | null>(null);

  protected submit(): void {
    const pick = this.control.value;
    if (!pick) return;
    this.resolve.emit({ pick });
  }
}
